export const isSupportedRouterNavigation = ({
  appRouterPathPrefixes,
  to,
  siteBasePath,
}: {
  appRouterPathPrefixes: string[];
  to: string;
  siteBasePath: string;
}) => {
  if (typeof window === "undefined") return false;

  const currentPath = window.location.pathname.replace(siteBasePath, "");

  const isFromAppRouter = appRouterPathPrefixes.some((prefix) =>
    currentPath.startsWith(prefix),
  );

  const toPath = to.startsWith(siteBasePath)
    ? to.slice(siteBasePath.length)
    : to;

  if (currentPath === toPath) {
    return false;
  }

  const isToAppRouter = appRouterPathPrefixes.some((prefix) =>
    toPath.startsWith(prefix),
  );

  return isFromAppRouter === isToAppRouter;
};
